import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '@compass/material';
import { ReactiveFormsModule } from '@angular/forms';
import { BusinessFormComponent } from './business-form/business-form.component';
import { BusinessTableComponent } from './business-table/business-table.component';
import { BusinessReshapeService } from './business.reshape.service';
import { BusinessViewerService } from './business-viewer.service';
import { BusinessApiService } from './business-api.service';
import { BusinessFormOptionsService } from './business-form/business-form-options.service';
import { MapService } from './map/map.service';
import { MapLoaderComponent } from './map-loader/map-loader.component';
import { BusinessMenuComponent } from './business-menu/business-menu.component';
import { BusinessSidenavComponent } from './business-sidenav/business-sidenav.component';
import { IndicatorsSelectModule } from '@compass/indicators-select';
import { IndicatorService } from '@compass/utils/navigation';
import { CompassMapIndicatorsService } from '@compass/utils/leaflet';
import { Mathematics, ThematicKeySymbol } from '@compass/utils/misc';
import { UtilsD3Module } from '@compass/utils/d3';
//import { DataModule } from '@compass/data';
import { CrossfilterModule } from '@compass/crossfilter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MapComponent } from './map/map.component';
import { BusinessFilterComponent } from './business-filter/business-filter.component';
import { BusinessIndicatorsComponent } from './business-indicators/business-indicators.component';
import { FormModule } from '@compass/form';
import { MapModule } from '@compass/map';

//import { FormModule } from '@compass/form';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    IndicatorsSelectModule,
    UtilsD3Module,
    FormModule,
    CrossfilterModule,
    MatAutocompleteModule,
    MapModule
  ],
  declarations: [
    BusinessFormComponent,
    BusinessTableComponent,
    MapLoaderComponent,
    BusinessMenuComponent,
    BusinessSidenavComponent,
    MapComponent,
    BusinessFilterComponent,
    BusinessIndicatorsComponent,


  ],
  exports: [
    BusinessFormComponent,
    BusinessTableComponent,
    MapLoaderComponent,
    BusinessMenuComponent,
    BusinessSidenavComponent,
    BusinessFilterComponent

  ],
  providers: [
    BusinessReshapeService,
    BusinessViewerService,
    BusinessApiService,
    BusinessFormOptionsService,
    MapService,
    IndicatorService,
    CompassMapIndicatorsService,
    Mathematics,
    ThematicKeySymbol,
  ]
})
export class BusinessModule {
}
